export default {
  state: {
    visibility: false
  },
  mutations: {
    SET_ADD_CAROUSEL_BANNER_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    }
  },
  actions: {}
}
